var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('click-confirm',{attrs:{"messages":{title: 'Are you sure?', yes: 'Yes', no: 'No'},"yes-class":"btn btn-success","no-class":"btn btn-danger","yes-icon":"fa fa-thumbs-up","no-icon":"fa fa-thumbs-down"}},[_vm._t("default",null,null,_vm.$attrs)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e41917ae","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/VueConfirmClick.vue
// module id = null
// module chunks = 